/**
 * Number formatting utilities
 * جميع الأرقام والتواريخ في التطبيق تعرض بالتقويم الميلادي والأرقام الإنجليزية
 */

export function formatCurrency (amount: number | undefined | null, currency = 'SAR'): string {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return `0 ${currency === 'SAR' ? 'ر.س' : currency}`;
  }

  const isWholeNumber = amount % 1 === 0;
  const formattedNumber = isWholeNumber
    ? amount.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})
    : amount.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2});

  const currencySymbol = currency === 'SAR' ? 'SAR' : currency;
  return `${currencySymbol} ${formattedNumber}`;
}

export function formatNumber (number: number | undefined | null, locale = 'en-US'): string {
  if (number === undefined || number === null || isNaN(number)) {
    return '0';
  }
  return number.toLocaleString(locale);
}

export function formatPercentage (percentage: number | undefined | null): string {
  if (percentage === undefined || percentage === null || isNaN(percentage)) {
    return '0.0%';
  }
  return `${percentage.toFixed(1)}%`;
}
